import { useQuery } from '@tanstack/react-query'
import instance from '../api'
import { useAuthContext } from '../../context/auth/auth'
import {
  OrganizationDetails,
  OrganizationTypes,
} from '../../interfaces/organization'

const getOrganization = async (
  token: string,
  id: string,
): Promise<OrganizationTypes & OrganizationDetails> => {
  const response = await instance.get(`/organizations/organization/${id}/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data.data
}

const useOrganization = (id: string) => {
  const { token } = useAuthContext()
  return useQuery({
    queryKey: ['organization', id],
    queryFn: () => getOrganization(token!, id),
    enabled: !!id,
  })
}

export default useOrganization
